import { Outlet } from 'react-router-dom';
import { PropTypes as MobXPropTypes } from 'mobx-react';

const Templates = () => {
  return (
    <section className={'page-container'}>
      <Outlet />
    </section>
  );
};

Templates.propTypes = {
  paymentStore: MobXPropTypes.observableObject
};

export default Templates;
